import { allSeeds } from '../data/seedData';

export const rarities = ['Common', 'Uncommon', 'Rare', 'Epic', 'Legendary'];

export const seedTypes = [
  { 
    name: 'Summer',
    id: 'summerSeeds',
    emoji: '🌻',
    filter: (seed) => seed.season === 'summer',
    imagePath: '/images/seeds/summer/common/preview.png'
  },
  { 
    name: 'Spring',
    id: 'springSeeds',
    emoji: '🌸',
    filter: (seed) => seed.season === 'spring',
    imagePath: '/images/seeds/spring/common/preview.png'
  },
  { 
    name: 'Limited',
    id: 'limitedSeeds',
    emoji: '🌱',
    filter: (seed) => seed.season === 'limited',
    imagePath: '/images/seeds/limited/common/preview.png'
  },
];

export function formatGrowTime(seconds) {
  if (seconds === 0) return '0m';
  
  const days = Math.floor(seconds / 86400);
  
  if (days > 0) {
    // For times 24h or more, show in days and hours
    const hours = Math.floor((seconds % 86400) / 3600);
    return `${days}d${hours > 0 ? ` ${hours}h` : ''}`.trim();
  } else {
    // For times under 24h, show in hours and minutes
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    
    if (hours > 0) {
      return `${hours}h${minutes > 0 ? ` ${minutes}m` : ''}`.trim();
    } else {
      return `${minutes}m`;
    }
  }
}

export function calculateBpPerMinute(biopoints, growTimeInSeconds) {
  // Convert seconds to minutes for BP/min calculation
  const growTimeInMinutes = growTimeInSeconds / 60;
  return biopoints / growTimeInMinutes;
}

export function getFilteredSeeds(tabValue, searchQuery, seedTypes) {
  let seeds = [];
  if (searchQuery) {
    const query = searchQuery.toLowerCase();
    seeds = Object.values(allSeeds).flat().filter(seed =>
      seed.name.toLowerCase().includes(query)
    );
  } else {
    const currentType = seedTypes[tabValue];
    if (!currentType) return [];
    seeds = allSeeds[currentType.id] || [];
  }
  return [...seeds].sort((a, b) => a.name.localeCompare(b.name));
}

export function getSeedRarities(seed) {
  // Returns a map of rarity type to rarity data for a given seed
  const seedRarities = {};
  if (seed.rarity) {
    seed.rarity.forEach(r => {
      if (r && r.type) {
        seedRarities[r.type] = r;
      }
    });
  }
  return seedRarities;
} 